export default [
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'BMC-01',
        data: [
            {
                "cross_section": "30117",
                "diffs": [
                    {
                        "name": "Bridge #1",
                        "low_flow": [
                            {
                                "name": "Compute",
                                "base": [
                                    "Energy",
                                    "Momentum"
                                ],
                                "compare": [
                                    "Yarnell"
                                ]
                            },
                            {
                                "name": "Pier Shape K",
                                "base": null,
                                "compare": null
                            }
                        ],
                        "high_flow": [
                            {
                                "name": "Submerged Inlet Cd",
                                "base": null,
                                "compare": "0.16"
                            },
                            {
                                "name": "Max Low Chord",
                                "base": null,
                                "compare": "0.24"
                            }
                        ],
                        "low_flow_ws": [
                            {
                                "name": "Submerged Inlet Cd",
                                "base": null,
                                "compare": "0.16"
                            },
                            {
                                "name": "Max Low Chord",
                                "base": null,
                                "compare": "0.24"
                            }
                        ],
                        "removed_bridges": [{name: 'Bridge #1', base: '*', compare: '*'}, {name: 'Bridge #2', base: '*', compare: '*'}]
                    }
                ]
            }
        ]
    }
]